<template>
	<div v-if="isPopup" class="special special-popup">
		<img src="/images/special-popup.svg" alt="Popup" />
		<div class="special-description">
			<h3 class="special-title">Restaurant is Here!</h3>
			<h4 class="special-subtitle">Order from the popup below</h4>
		</div>
	</div>
</template>

<script>
export default {
	name: "PopupBanner",
	computed: {
		isPopup() {
			return this.$store.getters.isPopup
		}
	}
}
</script>